import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SearchBar = ({ onSearch, onLocationToggle, isLocationEnabled = false }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [location, setLocation] = useState('');

  useEffect(() => {
    // Simulate location detection
    if (isLocationEnabled) {
      setLocation('New York, NY');
    } else {
      setLocation('');
    }
  }, [isLocationEnabled]);

  const handleSearch = (e) => {
    e?.preventDefault();
    onSearch(searchQuery);
  };

  const handleLocationClick = () => {
    onLocationToggle();
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-4 mb-6">
      <form onSubmit={handleSearch} className="space-y-4">
        <div className="flex flex-col sm:flex-row gap-3">
          <div className="flex-1">
            <Input
              type="search"
              placeholder="Search events, artists, venues..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              className="w-full"
            />
          </div>
          <Button
            type="submit"
            variant="default"
            iconName="Search"
            className="sm:w-auto w-full"
          >
            Search
          </Button>
        </div>
        
        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={handleLocationClick}
            className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm transition-colors ${
              isLocationEnabled 
                ? 'bg-primary text-primary-foreground' 
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            <Icon name="MapPin" size={16} />
            <span>{location || 'Enable location'}</span>
          </button>
          
          <div className="text-xs text-muted-foreground">
            {isLocationEnabled ? 'Showing nearby events' : 'All locations'}
          </div>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;